// extracted by mini-css-extract-plugin
export var container = "_5y-0";
export var fallback = "_5y-5";
export var fallbackIcon = "_5y-6";
export var hidden = "_5y-2";
export var image = "_5y-3";
export var loaded = "_5y-4";
export var placeholder = "_5y-1";